<template>
    <div class="contactsContainer">
        <div style="display:flex">
            <h1 style="margin:auto">{{$t('contactInformation.contactInf')}}</h1>
        </div>
        <v-row>
            <v-col cols="3"></v-col>
            <v-col>
                <div style="display: block">
                    <h2>{{$t('contactInformation.adress')}}</h2>
                    <p>{{this.contacts.address}}</p>
                </div>
            </v-col>
        </v-row>
        <div style="display:flex;  ">
            <v-row>
                <v-col width="20%"></v-col>
                <v-col  width="30%">
                    <h3>{{$t('contactInformation.phone')}}</h3>
                    <p v-for="(numberOfPhone, index) in contacts.numberOfPhones" :key="index">
                        <a v-bind:href="'tel:'+ numberOfPhone" >{{numberOfPhone}}</a>
                    </p>
                    <h3>{{$t('contactInformation.supPhone')}}</h3>
                    <p v-for="(supportNumberOfPhone, index) in contacts.supportNumberOfPhones" :key="index">
                        <a v-bind:href="'tel:'+ supportNumberOfPhone">{{supportNumberOfPhone}}</a>
                    </p>
                </v-col>

                <v-col width="30%">
                    <h3>E-mail</h3>
                    <p v-for="(email, index) in contacts.emails" :key="index">
                        <a v-bind:href="'mailto:'+ email">{{email}}</a>
                    </p>
                    <h3>{{$t('contactInformation.supEmail')}}</h3>
                    <p v-for="(supportEmail, index) in contacts.supportEmails" :key="index">
                        <a v-bind:href="'mailto:'+ supportEmail">{{supportEmail}}</a>
                    </p>
                </v-col>
                <v-col width="20%"></v-col>

            </v-row>
        </div>
    </div>
</template>

<script>
export default {
  data: () => ({
    contacts: {}
  }),
  async created() {
    this.contacts = this.$store.getters.contactsSettings
  }
}
</script>
<style lang="scss">
.contactsContainer {
    margin: auto;
    h1 {
        font-size: 25px;
    }
    h2 {
        font-size: 20px;
    }
    h3 {
        font-size: 17px;

    }
    a {
        font-size: 15px;
        line-height:25px;
        letter-spacing: 0.2rem;
        text-decoration: none;
    }
    p {
        font-size: 15px;
        line-height:25px;
    }
}

</style>
